/**
 * AiCloud - Yeni Agent Ekle
 * Mevcut CreateAgent sayfasina yonlendirir (ayni form)
 */

import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default function AddAgentPage() {
  const navigate = useNavigate()

  useEffect(() => {
    // Mevcut agent olusturma sayfasina yonlendir
    navigate('/agents/create', { replace: true })
  }, [navigate])

  return null
}
